/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cv_Extract_Form_Enum_First5Inputs */

const en_cv_extract_form_enum_first5 = /** @type {(inputs: Cv_Extract_Form_Enum_First5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`First experience`)
};

const de_cv_extract_form_enum_first5 = /** @type {(inputs: Cv_Extract_Form_Enum_First5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erste Erfahrung`)
};

/**
* | output |
* | --- |
* | "First experience" |
*
* @param {Cv_Extract_Form_Enum_First5Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const cv_extract_form_enum_first5 = /** @type {((inputs?: Cv_Extract_Form_Enum_First5Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cv_Extract_Form_Enum_First5Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_cv_extract_form_enum_first5(inputs)
	return en_cv_extract_form_enum_first5(inputs)
});
export { cv_extract_form_enum_first5 as "cv_extract_form_enum_FIRST" }